import { request } from 'utils/request';
import { header } from 'utils/auth';

export const fetchManufacturers = async (): Promise<any> => {
  try {
    const requestURL = `/api/v1/admin/manufacturers/newmanufacturers`;
    const response: any = await request(requestURL, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
      }),
    });

    if (!response) {
      throw new Error('Failed to fetch manufacturers');
    }
    return response;
  } catch (error) {
    console.error('Error fetching manufacturers:', error);
    throw error;
  }
};
